import React from 'react';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import type { SearchBarProps } from '../types';

const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, onClear, inputRef }) => {
    return (
        <div className="posv2-search">
            <SearchIcon className="posv2-search__icon" />
            <input
                ref={inputRef}
                className="posv2-search__input"
                type="text"
                placeholder="Search items... (Ctrl+K)"
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />
            {value && (
                <IconButton size="small" onClick={onClear} aria-label="Clear search">
                    <CloseIcon fontSize="small" />
                </IconButton>
            )}
        </div>
    );
};

export default React.memo(SearchBar);
